import { createAction } from '@reduxjs/toolkit';

export const TOGGLE_PINNED_CARD_ACTION_TYPE = 'saga/togglePinnedCard';
export const togglePinnedCardAction = createAction(TOGGLE_PINNED_CARD_ACTION_TYPE);
